import styles from "./stepper.module.scss";
import type { StepperViewProps } from "./types-stepper";

/**
 * Stepper (Figma DS - OceanPact `stepper`, 6978:73977): horizontal, vertical (`Orientation=Vertical` 6978:73978, com o painel
 * do passo) e cartões (Hub-Desenvolvimento 4702:62220). A tela controla qual passo está ativo.
 */
export function StepperView({
  compact,
  orientation,
  variant,
  testId,
  className,
  style,
  rest,
  children,
}: StepperViewProps) {
  return (
    <ol
      className={[styles.root, className].filter(Boolean).join(" ")}
      style={style}
      data-compact={compact ? "" : undefined}
      data-orientation={orientation}
      data-variant={variant}
      data-testid={testId}
      {...rest}
    >
      {children}
    </ol>
  );
}
